export function getParams (state){
    return state.params
}


// WEBPACK FOOTER //
// ./src/modules/users/getters.js